import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./css/livestream.scss";
import "./css/mobile-responsive.scss";
import "select2";
import { LiveStreamAppProvider } from "./ContextStore/Store";
import { BrowserRouter as Router } from "react-router-dom";
import { installConsoleCapture } from "./utils/MediaDiagnostics";

// Keep a rolling buffer of console output so the Preview Screen troubleshooter can include it
installConsoleCapture();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <LiveStreamAppProvider>
      <App />
    </LiveStreamAppProvider>
  </Router>
);
